namespace GeniuzPOS.PosShift {
    export interface ReportSaleTaxTreeTaxForm {
        DocDate: Serenity.DateEditor;
        PosId: Serenity.StringEditor;
        PosPermitNo: Serenity.StringEditor;
        HdDtFg: Serenity.IntegerEditor;
        DocType: Serenity.IntegerEditor;
        TaxInvoiceNo: Serenity.StringEditor;
        RefRecieptNo: Serenity.StringEditor;
        StartDocNo: Serenity.StringEditor;
        EndDocNo: Serenity.StringEditor;
        BuyerName: Serenity.StringEditor;
        TaxId: Serenity.StringEditor;
        BranchName: Serenity.StringEditor;
        DocAmt: Serenity.DecimalEditor;
        NonVatAmt: Serenity.DecimalEditor;
        TotalAmt: Serenity.DecimalEditor;
        ExVatAmt: Serenity.DecimalEditor;
        VatAmt: Serenity.DecimalEditor;
    }

    export class ReportSaleTaxTreeTaxForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.ReportSaleTaxTreeTax';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportSaleTaxTreeTaxForm.init)  {
                ReportSaleTaxTreeTaxForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(ReportSaleTaxTreeTaxForm, [
                    'DocDate', w0,
                    'PosId', w1,
                    'PosPermitNo', w1,
                    'HdDtFg', w2,
                    'DocType', w2,
                    'TaxInvoiceNo', w1,
                    'RefRecieptNo', w1,
                    'StartDocNo', w1,
                    'EndDocNo', w1,
                    'BuyerName', w1,
                    'TaxId', w1,
                    'BranchName', w1,
                    'DocAmt', w3,
                    'NonVatAmt', w3,
                    'TotalAmt', w3,
                    'ExVatAmt', w3,
                    'VatAmt', w3
                ]);
            }
        }
    }
}
